import * as React from 'react';
import { connect } from 'react-redux';

import { Svg } from '@src/assets/svg/Svg';
import TabWrap from '@src/components/tabs/tab-wrap/TabWrap';
import Preloader from '@src/components/preloader/Preloader';
import TabManager from '@src/containers/login-overlay/tab-manager/TabManager';
import './LoginOverlay.scss';
import { Actions } from '@src/constants/Constants';
import { ILoginState, ILoginView } from '@src/reducers/LoginReducer';
import { __ } from '@src/utils/i18Abstract';
import { IPreloaderState } from '@src/reducers/PreloaderReducer';
import { RootState } from '@src/reducers';
import Alert from '@src/components/alert/Alert';
import ConnectedAlert from '@src/containers/connected-alert/ConnectedAlert';

interface IReduxState {
    view: ILoginView;
    isLoading: boolean;
    showPreloader: boolean;
}

interface IReduxActions {
    hideOverlay: () => void;
    changeUI: (showRegisterView: boolean) => void;
}

type IAllProps = IReduxState & IReduxActions;

class LoginOverlay extends React.Component<IAllProps, {}> {
    overlayBody: any;

    resizeEvent() {
        const body: any = document.querySelector('.overlay-wrap');
        const wrap: any = document.querySelector('.LoginOverlay-wrap');

        if (body && wrap) {
            const bounds: any = body.getBoundingClientRect();
            console.log(bounds.top);
            if (bounds.top < 0) {
                wrap.classList.add('top-fixed');
            } else {
                wrap.classList.remove('top-fixed');
            }
        }
    }

    componentDidMount() {
        this.resizeEvent();
        // window.addEventListener('resize', this.resizeEvent);
    }

    componentWillUnmount() {
        // window.removeEventListener('resize', this.resizeEvent);
    }

    render() {
        const {
            hideOverlay,
            changeUI,
            view,
            isLoading,
            showPreloader,
        } = this.props;

        return (
            <div
                className="LoginOverlay-wrap"
                onClick={() => {
                    if (isLoading) {
                        return;
                    }
                    hideOverlay();
                }}>

                <div
                    ref={e => (this.overlayBody = e)}
                    className="overlay-wrap"
                    onClick={e => e.stopPropagation()}>

                    {showPreloader && <Preloader darkBackground={isLoading}/>}

                    <ConnectedAlert/>

                    <div className="overlay-header">
                        <div className="header-inner">
                            <h1 className="overlay-title">{__('myProfile')}</h1>
                            <span
                                onClick={hideOverlay}
                                className="close-button"
                                dangerouslySetInnerHTML={{
                                    __html: Svg.close(23),
                                }}
                            />

                        </div>

                        <TabWrap
                            onTabClick={index => changeUI(Boolean(index))}
                            tabs={[
                                {
                                    isActive:
                                        view === ILoginView.login ||
                                            view === ILoginView.forgotPassword,
                                    title: __('tabLogin'),
                                },
                                {
                                    isActive: view === ILoginView.register,
                                    title: __('tabRegister'),
                                },
                            ]}
                        />
                    </div>

                    <TabManager />
                </div>

            </div>
        );
    }
}

const mapStateToProps = (state: RootState): IReduxState => {
    const loginState: ILoginState = state.loginState;
    const preloaderState: IPreloaderState = state.preloaderState;
    return {
        isLoading: loginState.isLoading,
        showPreloader: preloaderState.isVisible,
        view: loginState.view,
    };
};

const mapDispatchToProps = (dispatch: any): IReduxActions => {
    return {
        hideOverlay: () => dispatch({ type: Actions.HIDE_OVERLAY }),
        changeUI: showRegisterView =>
            dispatch({
                type: Actions.CHANGE_VIEW,
                payload: showRegisterView
                    ? ILoginView.register
                    : ILoginView.login,
            }),
    };
};

export default connect<IReduxState, IReduxActions, null>(
    mapStateToProps,
    mapDispatchToProps,
)(LoginOverlay);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/login-overlay/LoginOverlay.tsx